import { createStore } from 'solid-js/store'

import './style/login.scss'
import { api_user_login_post } from 'api'

export const Login = () => {
    type State = {
        username: string
        password: string
    }
    const [state, setState] = createStore<State>({ username: '', password: '' })

    async function submit(e: SubmitEvent) {
        e.preventDefault()
        let res = await api_user_login_post({...state})
        if (res.ok()) location.reload()
    }

    return (
        <div class='login-fnd'>
            <form class='login-card' onSubmit={submit}>
                <h1>Login</h1>
                <label for='username'>
                    username:
                    <input
                        class='styled'
                        id='username'
                        autocomplete='username'
                        name='username'
                        onInput={e =>
                            setState({ username: e.currentTarget.value })
                        }
                    />
                </label>

                <label for='password'>
                    password:
                    <input
                        class='styled'
                        id='password'
                        autocomplete='password'
                        name='password'
                        onInput={e =>
                            setState({ password: e.currentTarget.value })
                        }
                    />
                </label>
                <button type='submit' class='styled'>Login</button>
            </form>
        </div>
    )
}
